<div>
    <div class="card border-radius-0 mt-1 p-0">
        <div class="card-header">
            Asset Details
        </div>
        <div class="card-body">
            <div class="row pb-2">
                <div class="col-md-4 px-1">
                    <label class="form-font-label">Purchase Reference No.</label>
                    <div class="row text-right">
                        <div>{{TableDatas[0].PurchaseRefNo}}</div>
                    </div>
                </div>
                <div class="col-md-3 px-1">
                    <label class="form-font-label">Purchase Date</label>
                    <div class="row text-right">
                        <div>{{TableDatas[0].PurchaseDate | date: 'dd MMM yyyy'}}</div>
                    </div>

                </div>
                <div class="col-md-4 px-1">
                    <div class="col-md-3">
                        <label class="form-font-label">Attachment</label>
                    </div>
                    <div class="col-md-9" *ngIf="(TableDatas[0].Attachment == '' || TableDatas[0].Attachment == null)">
                        <label class="form-font-label">
                            No Attachment
                        </label>
                    </div>
                    <div class="col-md-9"
                        *ngIf="((TableDatas[0].Attachment != '') && (TableDatas[0].Attachment != null))">
                        <a [href]="Link(TableDatas[0].Attachment)" target="_blank"
                            class="btn btn-outline-primary btn-sm" role="button"><i class="bi bi-paperclip"></i>View</a>
                    </div>
                </div>
            </div>
            <div class="row pb-2">
                <div class="col-md-4 px-1">
                    <label class="form-font-label">Branch</label>
                    <div class="row text-right">
                        <div>{{TableDatas[0].BranchName}}</div>
                    </div>

                </div>
                <div class="col-md-3 px-1">
                    <label class="form-font-label">Vendor Name</label>
                    <div class="row text-right">
                        <div>{{TableDatas[0].VendorName}}</div>
                    </div>
                </div>
                <div class="col-md-2 px-1">
                    <label class="form-font-label">Total Asset Count</label>
                    <div class="row text-right">
                        <div>{{TableDatas[0].TotalCount}}</div>
                    </div>
                </div>

            </div>
            <div class="row mt-1 p-0">
                <div class="card-body p-1">

                    <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                        class="customeDatatable table table-bordered">
                        <thead class="table-light">
                            <tr>
                                <th scope="col" style="width: 5px; ">#</th>
                                <th scope="col" style="width: 200px; ">Asset Name </th>
                                <th scope="col" style="width: 200px; ">Asset Number </th>
                                <th scope="col" style="width: 200px;">Serial Number </th>
                                <th scope="col" style="width: 200px;">Manufacturer</th>
                                <th scope="col" style="width: 200px;">Model </th>
                                <th scope="col" style="width: 300px;">Warranty Expiry Date </th>
                                <th scope="col" style="width: 200px;">Cost</th>
                                <th scope="col" style="width: 300px;">Remarks </th>
                                <th scope="col" style="width: 300px;">Description</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let TableData of TableDatas; let i = index">
                                <th scope="row">{{i+1}}</th>
                                <td>{{TableData['AssetMasterName']}}</td>
                                <td>{{TableData['AssetNumber']}}</td>
                                <td>{{TableData['SerialNumber']}}</td>
                                <td>{{TableData['Manufacturer']}}</td>
                                <td>{{TableData['Model']}}</td>
                                <td>{{TableData['WarrantyExpiryDate'] | date: 'dd MMM yyyy'}}</td>
                                <td>{{TableData['Cost']}}</td>
                                <td>{{TableData['Remarks']}}</td>
                                <td>{{TableData['Description']}}</td>
                            </tr>
                        </tbody>
                    </table>

                </div>
            </div>
        </div>
    </div>